import { useEffect, useState } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import { defaultBooking } from "../schema";

/**
 * Subscribe to a single booking. Pass "new" for a draft with default shape.
 *
 * @param {string} id
 * @returns {{ booking: object|null, loading: boolean, error: Error|null, isNew: boolean }}
 */
export function useBooking(id) {
  const isNew = id === "new";
  const [booking, setBooking] = useState(isNew ? defaultBooking() : null);
  const [loading, setLoading] = useState(!isNew);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isNew) {
      setBooking(defaultBooking());
      setLoading(false);
      return;
    }
    if (!id) return;
    setLoading(true);
    const unsub = onSnapshot(
      doc(db, "bookings", id),
      (snap) => {
        if (!snap.exists()) {
          setBooking(null);
          setError(new Error("Booking not found"));
        } else {
          setBooking({ id: snap.id, ...snap.data() });
          setError(null);
        }
        setLoading(false);
      },
      (err) => {
        console.error("useBooking error:", err);
        setError(err);
        setLoading(false);
      }
    );
    return unsub;
  }, [id, isNew]);

  return { booking, loading, error, isNew };
}
